module.exports = __webpack_public_path__ + "static/media/ardmac.c26e0bda.png";